
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { Search, Refresh, Clear, RemoveCircle, AddCircleOutlineOutlined, ManageSearch } from "@mui/icons-material";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import { useGetForestOwnerQuery, useGetForestOwnerListQuery, useGetForestOwnerPresentationQuery } from "../../../../timber/apis/ForestOwner.api";
import { ForestOwnerNameDisplay, default as ForestOwnerName } from "../../../../timber/components/forestOwner/ForestOwnerDetail/ForestOwnerName";
import { toString as toStringForestOwner, PrimaryForestOwner } from "../../../../timber/types/models/ForestOwner";

import React from "react";
import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
    Container,
    Stack,
    Button,
    FormControl,
    Divider,
} from "@mui/material";

import { object, string, number, boolean, date, coerce, TypeOf, array } from 'zod';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import * as crudgen from "../../../../share";
import {formatDateTime, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import {useDebounce} from "react-use";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useDispatch} from "react-redux";
import useSearch from "../../../../hooks/useSearch";
import { Trans } from "@lingui/react/macro";
import { t, msg } from "@lingui/core/macro";

export const initialFormStateFn = () => { return {
    
    
        state: [],
        
    
    
    
} }

export const formObject = {
    
        name: string()
        .trim()
        .nullish(),
        
        
    
        state: array(string()
        .trim()
        .nullish()),
        
        
    
        forestOwnerId: string()
            .nullish(),
        
        
        forestOwnerIdInclude: boolean().default(false),
        
    
            startAtFrom: date().nullish(),
            startAtTo: date().nullish(),
            
        
        
    
};

export const formSchema = object(formObject);

export type FormInput = TypeOf<typeof formSchema>;

type IProps = {
    prefix?: string;
    setSearchInputValue: (search: string) => void;
    searchInputAdvanced: any;
    setSearchInputAdvanced: (any) => void;
    query: any;
    refetch: () => void;
}

const CuttingListSearch = (props: IProps) => {
    
    const {advancedSearch, search, updateSearch} = useSearch('Cutting')
    
    const [advanced, setAdvanced] = React.useState(advancedSearch);
    
    const {prefix = '', query} = props;
    
    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: advanced ? search : initialFormStateFn()
    });

    const {
        reset,
        watch,
        handleSubmit,
        formState: { isSubmitSuccessful },
    } = methods;
    
    
    const [, setForestOwnerInputValue, forestOwnerInputTerm] = useSearchDebounce();
    const { data: forestOwnerList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getForestOwnerListLoading,
        isFetching: getForestOwnerListFetching, 
    } = useGetForestOwnerPresentationQuery({
        list: {
            page: 0,
            pageSize: 12,
        },
        filter: {
            name: forestOwnerInputTerm || '',
                    nameOr: true,
                    },
    })
    
    
    
    const cancelSearch = React.useCallback((e: any) => {
        e.stopPropagation()
        props.setSearchInputAdvanced(undefined)
        setAdvanced(false)
    })
    
    const onAdvancedSubmitHandler: SubmitHandler<FormInput> = (values, e: any) => {
        props.setSearchInputAdvanced(values)
    };

    const forestOwnerIdInclude = watch(prefix + 'forestOwnerIdInclude');

    React.useEffect(() => {
        if (!advancedSearch) {
            props.setSearchInputValue(search)
        }
    }, []);

    const [advancedFormValues, setAdvancedFormValues] = React.useState(advanced ? search : initialFormStateFn())

    const [, cancelAdvancedFormValues] = useDebounce(() => {
        if (advanced) {
            handleSubmit(onAdvancedSubmitHandler)()
            updateSearch(advanced, advancedFormValues)
        }
    }, DEBOUNCE_TIME, [advancedFormValues, advanced])

    React.useEffect(() => {
        const subscription = watch((values) => {
            setAdvancedFormValues(values)
        });
        return () => {
            cancelAdvancedFormValues()
            subscription.unsubscribe()
        }
    }, [watch, cancelAdvancedFormValues]);
        
    if (!advanced)
    return (<Box
        component="form"
        onSubmit={(e) => {e?.preventDefault()}}
        noValidate
        sx={ { '& > :not(style)': { m: 1, width: '100%', padding: '1em' } } }
        autoComplete="off"
        data-testid="Cutting-search-form"
    >
        <TextField
            defaultValue={ !advancedSearch ? search : '' }
            label={t`Search (by Name)`}
            onChange={ (event) => {
                props.setSearchInputValue(event.target.value)
                updateSearch(false, event.target.value)
            } }
            variant="standard"
            slotProps={ {
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => {
                                    props.setSearchInputValue('')
                                    updateSearch(false, '')
                                } }
                                edge="end"
                            >
                                <Clear />
                            </IconButton>
                            <IconButton
                                onClick={() => setAdvanced(!advanced)}
                                edge="end"
                            >
                                <ManageSearch />
                            </IconButton>
                            
                            <IconButton
                                onClick={props.refetch}
                                edge="end"
                            >
                                <Refresh />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            } }
        />
    </Box>)
    if (advanced)
        return (<Container sx={ { marginBottom: '1em' } }>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={handleSubmit(onAdvancedSubmitHandler)}
                    noValidate
                    data-testid="Cutting-advanced-search-form"
                >
                    <FormControl fullWidth size="small">
                        
        
            
            <crudgen.FormInput
                    
                    name={ prefix + 'name' }
                    label={t`Name`}
                    clearable={true}
                    
                    
                    type='text'
                    
            />
            
        
    

                        
        
            
            <crudgen.FormSelect
                    
                    name={ prefix + 'state' }
                    label={t`State`}
                    options={ CuttingStatePairs }
                    optionLabelMap={ toStringCuttingState }
                    
                    multiple
            />
            
        
    

                        <Box sx={ {display: 'flex'} }>
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'forestOwnerId' }
                optionsLoading={ getForestOwnerListLoading || getForestOwnerListFetching }
                label={t`Forest Owner`}
                options={ forestOwnerList.items }
                valueMap={ (id) => useGetForestOwnerQuery(PrimaryForestOwner.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringForestOwner }
                onInputChange={ setForestOwnerInputValue }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><ForestOwnerNameDisplay data={option}/></li>)
                } }
                disabled={ !!forestOwnerIdInclude }
                
            
        />
        
    
<crudgen.FormCheckbox
        name={ prefix + 'forestOwnerIdInclude' }
        icon={<AddCircleOutlineOutlined />}
        checkedIcon={<RemoveCircle />}
    />
</Box>
                        
        
            
                
                <crudgen.FormDateRange
                    startName={ prefix + 'startAtFrom' }
                    endName={ prefix + 'startAtTo' }
                    startLabel={t`Start At From`}
                    endLabel={t`Start At To`}
                />
                
            
        
    

                        
                        
                        <Stack direction="row" spacing={1}>
                            <Button size="small"  variant="outlined" color="primary" type='submit' sx={ {display: 'none'} }>
                                <Search /> <Trans>Search</Trans>
                            </Button>
                            <Button size="small"  variant="outlined" color="primary" onClick={props.refetch}>
                                <Refresh /> <Trans>Refresh</Trans>
                            </Button>
                            <Button size="small" variant="outlined" onClick={cancelSearch} color="inherit">
                                <Trans>Cancel</Trans>
                            </Button>
                        </Stack>
                    </FormControl>
                </Box>
            </FormProvider>
        </Container>)
    
}

export default CuttingListSearch;
